module.exports = __webpack_public_path__ + "img/logo.8fea0295.svg";